import { XNGAGE_ELEMENTS } from "@awc/XDL/constants";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { FC, useEffect } from "react";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

const UtmParametersSessionTracker: FC<OwnProps> = () => {
    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }

        const params = new URLSearchParams(window.location.search);
        const urlUtmParams: { [key: string]: string } = {};

        params.forEach((value, key) => {
            if (key.toLowerCase().startsWith("utm_")) {
                urlUtmParams[key] = value;
            }
        });

        const hasUtmInUrl = Object.keys(urlUtmParams).length > 0;

        if (!hasUtmInUrl) {
            return;
        }

        Object.keys(sessionStorage).forEach(key => {
            if (key.toLowerCase().startsWith("utm_")) {
                sessionStorage.removeItem(key);
            }
        });

        Object.entries(urlUtmParams).forEach(([key, value]) => {
            sessionStorage.setItem(key, value);
        });
    }, []);
    return null;
};

const widgetModule: WidgetModule = {
    component: UtmParametersSessionTracker,
    definition: {
        group: XNGAGE_ELEMENTS,
        displayName: "Utm Parameters Session Tracker",
        allowedContexts: ["Header"],
    },
};

export default widgetModule;
